import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

export type RequestMethod = 'GET' | 'PUT' | 'POST' | 'DELETE';
export type RequestParams = HttpParams | { [param: string]: string | string[] };

/**
 * Base class for services that call the API Gateway
 */
@Injectable()
export abstract class ApiGatewayService {
  protected constructor(protected http: HttpClient, private basePath: string) {
    if (!this.basePath.endsWith('/')) {
      this.basePath += '/';
    }
  }

  private request<T>(method: RequestMethod, path: string | string[], params: RequestParams): Promise<T> {
    if (Array.isArray(path)) {
      path = path.join('/');
    }
    const url = new URL(this.basePath + path, environment.apigwURL);
    return this.http.request<T>(method, url.href, {
      params,
      responseType: 'json',
    }).toPromise();
  }

  protected get<T>(path: string | string[], params: RequestParams = {}): Promise<T> {
    return this.request('GET', path, params);
  }
}
